class KlaviyoSubscribe extends HTMLElement {
  constructor() {
    super();
    this.validEmailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  }

  connectedCallback() {
    this.initForm();
  }

  initForm() {
    const form = this.querySelector('.klaviyo-footer-newsletter');
    if (!form) return;

    const emailInput = form.querySelector('.form__input');
    const messagesDiv = this.querySelector('.klaviyo_messages');
    const successDiv = this.querySelector('.klaviyo_success');
    const listId = form.querySelector("[name='g']").value;

    const handleEmailInput = () => {
      const val = emailInput.value;
      if (val.length > 1 && val.match(this.validEmailRegex)) {
        messagesDiv.innerHTML = '';
        messagesDiv.style.display = 'none';
      }
    };

    emailInput.addEventListener('change', handleEmailInput);
    emailInput.addEventListener('input', handleEmailInput);
    emailInput.addEventListener('focus', handleEmailInput);

    form.addEventListener('submit', (e) => {
      e.preventDefault();
      this.handleFormSubmit(form, listId, emailInput.value);
    });
  }

  handleFormSubmit(form, listId, email) {
    let fieldsArr = ["Accepts Marketing"];
    let fieldsObj = {};
    let klaviyoObj = {};
  
    form.querySelectorAll('input').forEach(input => {
      if (
        input.type !== 'submit' &&
        input.type !== 'hidden' &&
        input.type !== 'email' &&
        input.name !== '$consent'
      ) {
        fieldsArr.push(input.name);
        fieldsObj[input.name] = input.value;
      }
      if (input.name === '$source') {
        fieldsArr.push('$source');
        fieldsObj['$source'] = input.value;
      }
    });
  
    fieldsObj['Accepts Marketing'] = true;
    klaviyoObj = { $fields: fieldsArr, ...fieldsObj };
  
    // Submit phone to Netlify SMS endpoint if present
    const telInput = form.querySelector('[type="tel"]');
    const phone = telInput?.value?.trim();
    const source = fieldsObj['$source'] || '';
    
    if (telInput && phone.length) {
      const smsUrl = `https://otm-shop.netlify.app/.netlify/functions/sms-consent?list_id=${listId}&email=${encodeURIComponent(email)}&phone=${encodeURIComponent(phone)}&source=${encodeURIComponent(source)}&marketing=true`;
  
      const requestOptions = {
        method: "GET",
        redirect: "follow"
      };
  
      fetch(smsUrl, requestOptions)
        .then((response) => response.text())
        .then((result) => console.log("SMS Consent Result:", result))
        .catch((error) => console.error("SMS Consent Error:", error));
    }
  
    this.handleSubmit(listId, klaviyoObj, email, form, "");
  }  

  handleSubmit(listId, obj, email, formSelector, redirectUrl) {
    const messagesDiv = this.querySelector('.klaviyo_messages');
    const successDiv = this.querySelector('.klaviyo_success');
    messagesDiv.innerHTML = '';

    if (email.length > 1 && email.match(this.validEmailRegex)) {
      if (listId !== '123456') {
        this.subscribe(listId, email, obj).then(response => {
          if (response.success) {
            messagesDiv.style.display = 'none';
            if (redirectUrl.length) {
              window.location.replace(redirectUrl);
            } else {
              successDiv.style.display = 'block';
            }
            formSelector.querySelectorAll(".form__input").forEach($i => {
              $i.value = "";
            });
            formSelector.classList.add("success");
          } else {
            successDiv.style.display = 'none';
            messagesDiv.style.display = 'block';
            response.errors.forEach(error => {
              let errorDiv = document.createElement('div');
              errorDiv.textContent = error;
              messagesDiv.appendChild(errorDiv);
            });
          }
        });
      } else {
        messagesDiv.style.display = 'block';
        messagesDiv.innerHTML = '<div>Please use a valid Klaviyo ID.</div>';
      }
    } else {
      messagesDiv.style.display = 'block';
      messagesDiv.innerHTML = '<div>Invalid Email</div>';
    }
  }

  subscribe(listId, email, data) {
    const url = 'https://manage.kmail-lists.com/ajax/subscriptions/subscribe';

    const payload = {
      g: listId,
      email: email,
      ...data
    };

    const formData = new URLSearchParams();

    for (let key in payload) {
      if (Array.isArray(payload[key])) {
        payload[key].forEach(value => {
          formData.append(key, value);
        });
      } else {
        formData.append(key, payload[key]);
      }
    }

    return fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      body: formData.toString()
    })
    .then(response => response.json())
    .then(data => {
      if (data.success) {
        return { success: true };
      } else {
        return { success: false, errors: data.errors || ['Subscription failed'] };
      }
    })
    .catch(error => {
      return { success: false, errors: [error.message] };
    });
  }
}

if (!customElements.get("klaviyo-subscribe")) {
  customElements.define('klaviyo-subscribe', KlaviyoSubscribe);
}